import AppBg from '../assets/app-bg.png';
import AppStore from '../assets/appstore.png';
import googlePlay from '../assets/googleplay.png';
import { Layout } from '../components/page-layout';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
`;
const FlexRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 0.5rem;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;
const LeftCol = styled.div`
  padding: 1rem 0;
  order: 2;
  @media (min-width: 768px) {
    order: 1;
    width: 700px;
  }
`;
const RightCol = styled.div`
  padding: 1rem 0;
  order: 1;
  @media (min-width: 768px) {
    order: 2;
  }
`;
const Title = styled.h3`
  color: #2E2E2E;
  font-weight: bold;
  font-size: 18px;
  @media (min-width: 768px) {
    font-size: 48px;
  }
`;
const Paragraph = styled.p`
  color: #7A7A7A;
  margin-top: 30px;
  margin-right: 150px;
  margin-bottom: 250px;
`;
const StoreRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 20px;
  gap: 20px;
  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 32px;
  }
`;
const StoreImg = styled.img`
  width: 200px;
  height: 65px;
  border-radius: 10px;
  margin-bottom: 0;
  @media (min-width: 768px) {
    margin-bottom: 0;
    margin-right: 0;
  }
`;
const AppImg = styled.img`
  width: 100%;
  height: auto;
  max-width: 335px;
  max-height: 335px;
  object-fit: contain;
  @media (min-width: 768px) {
    max-width: 594px;
    max-height: 594px;
  }
`;

export default function AppPage() {
  return (
    <Layout showCommonFooter={true}>
      <Container>
        <FlexRow>
          <LeftCol>
            <Title>
            The Official Sensforge App
            </Title>
            <Paragraph>
            Discover all the ways your camera can identify and celebrate your best moments
            </Paragraph>
            <StoreRow>
              <a href="https://apps.apple.com/us/app/sensforge/id6742210229">
                <StoreImg src={AppStore} alt="App Store" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.inc.sensforge&utm_source=na_Med">
                <StoreImg src={googlePlay} alt="Google Play" />
              </a>
            </StoreRow>
          </LeftCol>
          <RightCol>
            <AppImg src={AppBg} alt="Looking Ahead" />
          </RightCol>
        </FlexRow>
      </Container>
    </Layout>
  );
}
